/* Before / after comparator — ENGINE JS (Slice 35).
   ONE delegated document `input` listener filtered on .bfa__range, plus a
   window.__KV_BFA__ idempotence guard. No init, no DOMContentLoaded, no
   shopify:section:load — delegation survives editor DOM re-injection by
   construction (J-series delegation + no-init rationale). Range value →
   --bfa-pos on the widget root; clip-path + divider track it in CSS. */
if (!window.__KV_BFA__) {
  window.__KV_BFA__ = true;
  document.addEventListener('input', function (e) {
    var r = e.target;
    if (!r.classList || !r.classList.contains('bfa__range')) return;
    r.closest('.bfa').style.setProperty('--bfa-pos', r.value + '%');
  });
}
